import PropTypes from 'prop-types';
import React from 'react';
import { Box, Card, Divider, Typography } from '@mui/material';

/**
 * Apollo'nun Card + CardHeader + Divider + CardContent düzenini tek yerde
 * toplar. Başlık solda, isteğe bağlı aksiyon (segment düğmesi vb.) başlığın
 * yanında, açıklama sağa yaslı.
 *
 * padded=false verilirse içerik dolgusuz gelir; DataGrid gibi kendi kenar
 * boşluğunu yöneten bileşenler için.
 */
const SectionCard = ({ title, subtitle, action, padded = true, sx, children }) => (
  <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', ...sx }}>
    {(title || action || subtitle) && (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'wrap',
            px: 2,
            py: 1.5
          }}
        >
          {title && (
            <Typography variant="h5" sx={{ fontWeight: 500 }}>
              {title}
            </Typography>
          )}
          {action}
          <Box sx={{ flexGrow: 1 }} />
          {subtitle && (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
        <Divider />
      </>
    )}
    {padded ? <Box sx={{ p: 2, flexGrow: 1 }}>{children}</Box> : children}
  </Card>
);

SectionCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  action: PropTypes.node,
  padded: PropTypes.bool,
  sx: PropTypes.object,
  children: PropTypes.node
};

export default SectionCard;
